import React, { useState } from 'react'
import * as styles from './InputFormMail.module.scss'
import { useCalc } from '../../context/CalcContext'
import axios from 'axios'

const ZAPIERHOOK = 'https://hooks.zapier.com/hooks/catch/10362963/bkbutj1/'

const InputFormMail = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const { mrr, mom, me, gm, cb } = useCalc()
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const createPdf = (e) => {
    e.preventDefault()
    setError('')

    if (email && name) {
      setSent(true)
      axios
        .post(
          ZAPIERHOOK,
          JSON.stringify({
            values: { mrr, mom, me, gm, cb },
            email: email,
            company: name
          })
        )
        .then((res) => {
          setSent(true)
          // console.log('resp', res)
        })
    } else {
      setError('Please fill in all fields.')
    }

    return false
  }

  return (
    <div className={styles.inputFormWrapMail}>
      {/* <h5>Fill in your metrics</h5> */}
      {sent ? (
        <>
          <h2>Your full report will be in your inbox shortly!</h2>
        </>
      ) : (
        <form className={styles.inputForm}>
          <div className={styles.formCol}>
            <div className={styles.formGroup}>
              <input
                type="text"
                id="fejron-company-name"
                onChange={({ target }) => setName(target.value)}
                placeholder="Your company"
              ></input>
              <label htmlFor="fejron-calc-mrr">Your companies name</label>
              <div className="invalid-feedback">{errorMessage || ''}</div>
            </div>
          </div>
          <div className={styles.formCol}>
            <div className={styles.formGroup}>
              <input
                type="email"
                id="fejron-user-email"
                placeholder="Your e-mail"
                onChange={({ target }) => setEmail(target.value)}
              ></input>
              <label htmlFor="fejron-user-email">Your e-mail</label>
              {/* <div className="invalid-feedback">{errorMessage || ''}</div> */}
            </div>
          </div>
          <div className={styles.formCol}>
            <div className={styles.formGroup}>
              <button onClick={createPdf} className={styles.buttonCalculator}>
                Get report
              </button>
              {error && <div className={styles.invalidFeedback}>{error}</div>}
            </div>
          </div>
        </form>
      )}
    </div>
  )
}

export default InputFormMail
